import React, { useRef } from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import MarkerIconPng from "leaflet/dist/images/marker-icon.png";

const LayerMap = () => {
    const mapRef = useRef(null);
    const latitude = 49.88136;
    const longitude = 19.21483;

    return (
        <MapContainer center={[latitude, longitude]} zoom={18} ref={mapRef} style={{height: "80vh", minHeight: "600px", width: "100vw"}}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker
                position={[latitude, longitude]}
                icon={new Icon({ iconUrl: MarkerIconPng })}
                draggable={false}
            >
                <Popup position={[latitude, longitude]}>NaturMed - Gabinet Terapii Naturalnych</Popup>
            </Marker>
        </MapContainer>
    );
};

export default LayerMap;